import { ReactElement, useMemo } from 'react'
import UiConfig from 'ui/uiConfig/UiConfig'
import optimizeTours from '../optimizeTours'

type OptimizeViewConfigsParams = {
  isRegular: boolean
  datasetRefreshToken: string
  overrides: Partial<UiConfigProps>
}

export function useOptimizeViewConfigs({ isRegular, datasetRefreshToken, overrides }: OptimizeViewConfigsParams): {
  optimizeViewDefault: ReactElement
} {
  const optimizeViewDefaultFallback = useMemo(
    () => (
      <>
        <UiConfig
          type="optimize_production_plan"
          tourId={optimizeTours.widgetConstants.OPTIMIZE_WIDGET_1}
          datasetRefreshToken={datasetRefreshToken}
          {...overrides}
        />
        {isRegular ? (
          <>
            <UiConfig
              type="production_plan_forecast"
              tourId={optimizeTours.widgetConstants.OPTIMIZE_WIDGET_2}
              datasetRefreshToken={datasetRefreshToken}
              {...overrides}
            />
            <UiConfig
              type="production_plan_table"
              tourId={optimizeTours.widgetConstants.OPTIMIZE_WIDGET_3}
              datasetRefreshToken={datasetRefreshToken}
              {...overrides}
            />
          </>
        ) : null}
      </>
    ),
    [isRegular, overrides, datasetRefreshToken]
  )

  const optimizeViewDefault = useMemo(
    () => (
      <UiConfig
        type="optimize_view"
        datasetRefreshToken={datasetRefreshToken}
        {...overrides}
        fallback={optimizeViewDefaultFallback}
      />
    ),
    [overrides, optimizeViewDefaultFallback, datasetRefreshToken]
  )

  return { optimizeViewDefault }
}
